import { Type } from "class-transformer";
import { UserPermission } from "../auth/user-permission.model";
import { BaseModel } from "../base.model";

export class Role extends BaseModel {
  id: number;
  name: string;
  description: string;
  @Type(() => UserPermission)
  permissions: UserPermission[];
}
